import { render, staticRenderFns } from "./CurrentSimTypeSelector.vue?vue&type=template&id=5221b9f1&scoped=true"
import script from "./CurrentSimTypeSelector.vue?vue&type=script&lang=js"
export * from "./CurrentSimTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./CurrentSimTypeSelector.vue?vue&type=style&index=0&id=5221b9f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5221b9f1",
  null
  
)

export default component.exports